export const typographyStyles = {
  h1: {
    fontSize: '3rem',
    fontWeight: 400,
    lineHeight: 1.167,
    letterSpacing: '0em'
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 400,
    lineHeight: 1.235,
    letterSpacing: '0.00735em'
  },
  h5: {
    fontSize: '1.5rem',
    fontWeight: 400,
    lineHeight: 1.334,
    letterSpacing: '0em'
  },
  h6: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.0075em'
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em'
  }
}
